import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-6" }
const _hoisted_2 = { class: "flex flex-row space-x-4" }
const _hoisted_3 = ["disabled", "checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Action required.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientSupportingDocumentModal = _resolveComponent("PatientSupportingDocumentModal")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseTextInput = _resolveComponent("BaseTextInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayPdfDocument)
      ? (_openBlock(), _createBlock(_component_PatientSupportingDocumentModal, {
          key: 0,
          "document-id": _ctx.media.documentId,
          onClose: _ctx.closeModal
        }, null, 8, ["document-id", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "space-x-4 flex flex-row items-center cursor-pointer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.checkbox.click()))
      }, [
        _createElementVNode("input", _mergeProps({
          ref: "checkbox",
          class: ["form-checkbox outline-none", [_ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer', _ctx.checkboxClass]],
          type: "checkbox"
        }, _ctx.$attrs, {
          disabled: _ctx.disabled || _ctx.readonly,
          checked: _ctx.checked,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }), null, 16, _hoisted_3),
        _createElementVNode("div", {
          class: _normalizeClass(["flex text-lg font-regular", _ctx.checked ? 'text-gray-500' : 'text-gray-900'])
        }, _toDisplayString(_ctx.label), 3)
      ]),
      (_ctx.media && _ctx.media.documentId)
        ? (_openBlock(), _createBlock(_component_BaseButton, {
            key: 0,
            "right-icon": "arrow-top-right",
            size: "small",
            color: "gray",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.viewMedia()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.media.label), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.error || _ctx.reason.length || (!_ctx.reason.length && _ctx.validatedReason.length))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["p-6 space-y-4 rounded", _ctx.reason.length ? 'bg-gray-200' : 'bg-danger-500'])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-base font-medium leading-tight", _ctx.reason.length ? 'text-gray-900' : 'text-white'])
          }, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.actionMessage), 1)
          ], 2),
          _createVNode(_component_BaseTextInput, {
            modelValue: _ctx.reason,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
            readonly: _ctx.readonly,
            onBlur: _ctx.onChange,
            onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onKeyUp($event)))
          }, null, 8, ["modelValue", "readonly", "onBlur"])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}